export default "__VITE_ASSET__JISdja19__"